import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';
import { UserNotes } from './user-notes.types';

@Injectable({
    providedIn: 'root',
})
export class UserNotesService {
    private _notes: BehaviorSubject<UserNotes | null> =
        new BehaviorSubject<UserNotes | null>(null);

    constructor(private readonly _httpClient: HttpClient) {}

    get notes$(): Observable<UserNotes | null> {
        return this._notes.asObservable();
    }

    set notes(notes: UserNotes | null) {
        this._notes.next(notes);
    }

    /**
     * Vrai dès qu'au moins une partie active existe (pilote l'affichage du bouton infos).
     */
    get hasActiveNotes$(): Observable<boolean> {
        return this.notes$.pipe(
            map((notes) => !!notes?.sections?.some((section) => section.active)),
        );
    }

    /**
     * Récupère l'unique document de configuration des notes (société LEROUXTP).
     */
    public getUserNotes(): Observable<UserNotes> {
        return this._httpClient.get<UserNotes>(`/api/user-notes/one`).pipe(
            tap((res: UserNotes) => {
                this.notes = res;
            }),
        );
    }

    public update(id: string, form: Partial<UserNotes>): Observable<UserNotes> {
        return this._httpClient
            .patch<UserNotes>(`/api/user-notes/${id}`, form)
            .pipe(
                tap((res: UserNotes) => {
                    this.notes = res;
                }),
            );
    }
}
